import { LengthUnits } from "@/libs/units/length";
import type { RenderScenarioExportCols } from "./sizingExportTypes";

export const renderCorrelationsCols: RenderScenarioExportCols = ({
  scenario,
  calcs,
  targetUnits
}) => [
  ...(scenario.correlations.value?.casing_hazen_williams_coefficient !== 0 &&
  scenario.correlations.value?.casing_apply_hazen_williams_correction === true
    ? [
        {
          section: "Correlations",
          label: "Casing Hazen-Williams Coefficient",
          targetUnit: null,
          value: scenario.correlations.value?.casing_hazen_williams_coefficient
        }
      ]
    : [
        {
          section: "Correlations",
          label: "Casing Roughness",
          targetUnit: targetUnits.smallLengthUnit,
          value: LengthUnits.Inches.toStandardUnit(
            scenario.correlations.value?.casing_roughness_inches || 0
          ),
          decimalPlaceOverride: 4,
          hidden: !calcs.isScenarioEspShore.value
        }
      ]),
  {
    section: "Correlations",
    label: "Casing Flow Correlation",
    targetUnit: null,
    value: scenario.correlations.value?.casing_flow,
    hidden: !calcs.isScenarioEspShore.value
  },
  ...(scenario.correlations.value?.tubing_hazen_williams_coefficient !== 0 &&
  scenario.correlations.value?.tubing_apply_hazen_williams_correction === true
    ? [
        {
          section: "Correlations",
          label: "Tubing Hazen-Williams Coefficient",
          targetUnit: null,
          value: scenario.correlations.value?.tubing_hazen_williams_coefficient
        }
      ]
    : [
        {
          section: "Correlations",
          label: "Tubing Roughness",
          targetUnit: targetUnits.smallLengthUnit,
          value: LengthUnits.Inches.toStandardUnit(
            scenario.correlations.value?.tubing_roughness_inches || 0
          ),
          decimalPlaceOverride: 4,
          hidden: !calcs.isScenarioEspShore.value
        }
      ]),
  {
    section: "Correlations",
    label: "Tubing Flow Correlation",
    targetUnit: null,
    value: scenario.correlations.value?.tubing_flow,
    hidden: !calcs.isScenarioEspShore.value
  },
  {
    section: "Correlations",
    label: "Friction Loss Correlation",
    targetUnit: null,
    value: scenario.correlations.value?.friction_loss,
    hidden: !calcs.isScenarioEspShore.value
  },
  {
    section: "Correlations",
    label: "Bubble Point (Pb)",
    targetUnit: null,
    value: scenario.correlations.value?.bubble_point
  },
  {
    section: "Correlations",
    label: "Water Volume Factor (Bw)",
    targetUnit: null,
    value: scenario.correlations.value?.water_volume_factor
  },
  {
    section: "Correlations",
    label: "Solution Gas (Rso)",
    targetUnit: null,
    value: scenario.correlations.value?.solution_gor
  },
  {
    section: "Correlations",
    label: "Gas Compressibility (Z)",
    targetUnit: null,
    value: scenario.correlations.value?.gas_compressibility
  },
  {
    section: "Correlations",
    label: "Oil Volume Factor (Bo) Saturated",
    targetUnit: null,
    value: scenario.correlations.value?.oil_volume_factor_saturated
  },
  {
    section: "Correlations",
    label: "Oil Volume Factor (Bo) Undersaturated",
    targetUnit: null,
    value: scenario.correlations.value?.oil_volume_factor_undersaturated
  },
  {
    section: "Correlations",
    label: "Oil Density",
    targetUnit: null,
    value: scenario.correlations.value?.oil_density
  },
  {
    section: "Correlations",
    label: "Dead Oil Viscosity",
    targetUnit: null,
    value: scenario.correlations.value?.dead_oil
  },
  {
    section: "Correlations",
    label: "Water Salinity",
    targetUnit: targetUnits.concentrationUnit,
    value: scenario.correlations.value?.salinity_ppm
  },
  {
    section: "Correlations",
    label: "Water Viscosity",
    targetUnit: null,
    value: scenario.correlations.value?.water_viscosity
  },
  {
    section: "Correlations",
    label: "Saturated Oil",
    targetUnit: null,
    value: scenario.correlations.value?.saturated_oil
  },
  {
    section: "Correlations",
    label: "Gas Viscosity",
    targetUnit: null,
    value: scenario.correlations.value?.gas_viscosity
  },
  {
    section: "Correlations",
    label: "Under Saturated Oil",
    targetUnit: null,
    value: scenario.correlations.value?.under_saturated_oil
  },
  {
    section: "Correlations",
    label: "TDH Tuning Factor",
    targetUnit: null,
    value: scenario.correlations.value?.tdh_tuning_factor_ratio
  }
];
